import { apiClient } from "./client";
import type {
  CfoResearchBrief,
  CfoWorkCompleteRequest,
  CfoWorkCompleteResponse,
  CfoWorkStatsPeriod,
  CfoWorkStatsResponse,
} from "./types";

const project = (slug: string) => `/projects/${encodeURIComponent(slug)}`;

/** What the stored sources already say about a CFO company, its founders and
 *  its investors: where to start looking for what is missing. */
export async function getCfoResearch(slug: string, companyId: number): Promise<CfoResearchBrief> {
  return (
    await apiClient.get<CfoResearchBrief>(
      `${project(slug)}/cfo-workflow/companies/${companyId}/research`,
    )
  ).data;
}

/** Close the research on one company of a CFO lot and release it. "answered"
 *  names the operator's own answers (their observation ids); "not_found" holds
 *  for the company's current evaluation only. A retried `request_id` is
 *  answered with the first record (`replayed`). */
export async function completeCfoResearch(
  slug: string,
  companyId: number,
  request: CfoWorkCompleteRequest,
): Promise<CfoWorkCompleteResponse> {
  return (
    await apiClient.post<CfoWorkCompleteResponse>(
      `${project(slug)}/enrichment/cfo/${companyId}/complete`,
      request,
    )
  ).data;
}

/** CFO research performance for the caller, or the team for a manager. */
export async function getCfoResearchStats(
  slug: string,
  period: CfoWorkStatsPeriod,
  userId?: string,
): Promise<CfoWorkStatsResponse> {
  return (
    await apiClient.get<CfoWorkStatsResponse>(`${project(slug)}/enrichment/cfo/stats`, {
      params: { period, ...(userId ? { user_id: userId } : {}) },
    })
  ).data;
}
